import { ReactElement } from 'react';
import { Route } from 'react-router-dom';

import { analyticsRoutesConfig } from './analyticsRoutesConfig';
import { Analytics } from './screens/Analytics';

export function getAnalyticsRoutes(): ReactElement {
  return (
    <Route
      element={<Analytics />}
      path={analyticsRoutesConfig.analytics.path}
    />
  );
}
